import { render, staticRenderFns } from "./Task_UntreatedStudent.vue?vue&type=template&id=ef20377c&scoped=true&"
import script from "./Task_UntreatedStudent.vue?vue&type=script&lang=js&"
export * from "./Task_UntreatedStudent.vue?vue&type=script&lang=js&"
import style0 from "./Task_UntreatedStudent.vue?vue&type=style&index=0&id=ef20377c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef20377c",
  null
  
)

export default component.exports